import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import cookie from 'react-cookies'
import { User } from '../../models/user/user'
import Bar from './bar'
import { login, logout } from '../../models/user/authActions'
import { logout as logoutFromServer } from '../../models/user/service';
import { setAppLoaded, setCart, setDeliveryIsOff, setDimensions, setFavorites, setGiftCardSaleEnabled } from '../../models/application/applicationActions';
import { initUserCartAndFavorites, onDimensionsChange$ } from '../../helpers/utilities';
import { translationsService } from '../../models/translation/translationReducer';
import { setTranslations } from '../../models/translation/translationActions';
import { setLanguage } from '../../models/language/languageActions';
import { DeliveryWarningComponent } from '../MainPage/DeliveryWarningComponent';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';
import HolidayPopup from '../Checkout/HolidayPopup';
import { QueryOptions } from '../../helpers/query.options';
import { globalAttributeService } from '../../models/globalAttributes/service';
import { setFeatureFlags } from '../../models/application/applicationActions';
import { getFeatureFlags } from '../../helpers/featureFlags';


const Header = (props) => {
    const {
        login,
        app,
        setDimensions,
        logout,
        setDeliveryIsOff,
        setCart,
        setAppLoaded,
        setGiftCardSaleEnabled,
        setFeatureFlags,
        setFavorites,
        language,
        setTranslations,
        setLanguage,
        translations
    } = props
    const { loggedIn, user, LOGOUT } = props?.auth

    const { width } = useWindowDimensions()
    const [globalAttributes, setGlobalAttributes] = useState<{ uid: string; value: unknown }[]>([])
    const loggedInEmail = loggedIn ? user?.email : undefined

    useEffect(() => {
        setFeatureFlags(getFeatureFlags(globalAttributes))
    }, [globalAttributes, loggedInEmail, setFeatureFlags])

    const [open, setOpen] = useState(false)
    const [isWarningVisible, setIsWarningVisible] = useState(false)




    function handleResize() {
        onDimensionsChange$.next(window)
    }
    useEffect(() => {
        onDimensionsChange$.subscribe(
            debounced => {
                setDimensions({ width: window.innerWidth, height: window.innerHeight })
            }
        );
    }, []);

    useEffect(() => {

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }

    }, [])

    useEffect(() => {
        let active = true
        setGlobalAttributes([])
        loadGlobalAttributes(() => active)
        return () => { active = false }
    }, [loggedIn, loggedInEmail, user?.accessToken])

    const loadGlobalAttributes = async (isCurrent = () => true) => {
        const options = new QueryOptions()
        const resp = await globalAttributeService.list(options, loggedIn ? user?.accessToken : undefined)
        if (!isCurrent()) return
        const results = Array.isArray(resp?.results) ? resp.results : []
        setGlobalAttributes(results)
        const [deliveryDateTo] = results.filter((r) => r.uid === "delivery_holiday_date_to")
        const [giftCardSaleEnabled] = results.filter((r) => r.uid === "gift_card_sale_enabled")
        if (giftCardSaleEnabled) {
            setGiftCardSaleEnabled(giftCardSaleEnabled.value === true || giftCardSaleEnabled.value === "true")
        }
        if (deliveryDateTo) {
          const currentDate = new Date();
          const targetDate = new Date(deliveryDateTo.value);
          if (currentDate < targetDate ) {
            setDeliveryIsOff(true)
            
          }
        }
      }



    useEffect(() => {
        const cookieInterval = setInterval(() => {
            const usr = getCookie()
            if (!usr) {
                if (loggedIn) {
                    LOGOUT()
                    const user = new User();
                    user.delete()
                    window.location.href = "/"
                    setCart([])
                    localStorage.removeItem("cart")
                }
            }
        }, 5000)
        getCookie()
        return () => {
            clearInterval(cookieInterval);
        }
    }, [])
    useEffect(() => {
        const lang = localStorage.getItem("language")
        if (lang) {
            setLanguage(lang)
        }
        if (language !== lang) {
            if (!lang) {
                setLanguage("geo")
                translationsService.getTranslations('geo').then(translations => {
                    setTranslations(translations)
                    localStorage.setItem('translations', JSON.stringify(translations))
                })
            } else {
                setLanguage(lang)
                translationsService.getTranslations(lang).then(translations => {
                    setTranslations(translations)
                    localStorage.setItem('translations', JSON.stringify(translations))
                })
            }
        } else {
            translationsService.getTranslations(language).then(translations => {
                setTranslations(translations)
                localStorage.setItem('translations', JSON.stringify(translations))
            })
        }
        setAppLoaded(true)
    }, [language])


    useEffect(() => {
        initUserCartAndFavorites(setCart, setFavorites, login)
    }, [])

    useEffect(() => {
        if (app.deliveryIsOff) {
            setTimeout(() => {
                setIsWarningVisible(true)
            }, 1000)
        }
    }, [app.deliveryIsOff]);


    return <header>
        {width > 600 && <HolidayPopup translations={translations} language={language} open={open} setOpen={setOpen} />}
        {width > 600 && isWarningVisible && <DeliveryWarningComponent setOpen={setOpen} translations={translations} />}

        <Bar {...props} language={language} logoutUser={() => {
            logoutFromServer().then(r => {
                logout()
                setCart([])
                setFavorites([])
                localStorage.removeItem("cart")
                localStorage.removeItem("favorites")
                const user = new User();
                user.delete()
            })
        }} />
    </header>

}

const getCookie = () => {
    return cookie.load('user')
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.auth,
        app: state.app,
        loggedIn: state?.auth?.loggedIn,
        language: state.language,
        translations: state.translations
    }
}

export default connect(mapStateToProps, { login, logout, setDeliveryIsOff, setGiftCardSaleEnabled, setFeatureFlags, setCart, setFavorites, setTranslations, setLanguage, setAppLoaded, setDimensions })(Header)
